// extracted by mini-css-extract-plugin
export default {"wrappedContent":"wrappedContent__K7qhT"};